import get from "lodash/get";

export const addStaticRootToUrl = (url: string): string => {
  const staticRoot = get(window, "env.STATIC_ROOT", "/static/");
  return staticRoot + url;
};
